export const SET_ELEMENTS = 'set_elements'
export const SET_ACTIVE_ELEMENT = 'set_active_element'
export const UPDATE_ELEMENT = 'update_element'
export const ADD_ELEMENT = 'add_element'
export const REMOVE_ELEMENT = 'remove_element'
export const BATCH_UPDATE = 'batch_update'
export const DUPLICATE_ELEMENT = 'duplicate_element'
export const DELETE_ELEMENT = 'delete_element'
export const SEND_TO_BACK = 'send_to_back'
export const SEND_TO_FRONT = 'send_to_front'
export const SEND_TO_BACK_ONE = 'send_to_back_one'
export const SEND_TO_FRONT_ONE = 'send_to_front_one'


// WEBPACK FOOTER //
// ./src/store/types/elements.js